import { CircularProgress } from "@mui/material";
import styled from "@emotion/styled";
export const CustomStyledCircularProgress = styled(CircularProgress)({
  color: "rgba(0, 0, 0, 0.26)",
  marginLeft: "10px",
  fontSize: "small",
});
